// removed by extract-text-webpack-plugin
module.exports = {"medium":"only screen and (min-width: 768px)","large":"only screen and (min-width: 993px)","item":"item-3LWT5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/premium/_productChooser.css
// module id = 1246
// module chunks = 1